(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vb-gtt-setup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vb-gtt-setup')) {
    customElements.define('vb-gtt-setup', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          this.form = document.getElementById(this.dataset.formId);
          this.choice = this.querySelector('[data-setup-choice]');
          if (!this.form || !this.choice || this.dataset.ready !== 'true' || !this.dataset.variantId) return;
          this.choice.disabled = false;
          this.controller?.abort();
          this.controller = new AbortController();
          this.form.addEventListener('submit', this.submit.bind(this), {capture:true,signal:this.controller.signal});
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async submit(event) {
        if (!this.choice.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        if (!this.form.reportValidity()) return;
        this.busy = true;
        const formData = new FormData(this.form);
        const kitId = formData.get('id');
        const quantity = Number(formData.get('quantity') || 1);
        if (!kitId || !Number.isInteger(quantity) || quantity < 1) { this.busy = false; return; }
        const kit = {id:kitId,quantity};
        const properties = {};
        for (const [key,value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) kit.properties = properties;
        const plan = formData.get('selling_plan');
        if (plan) kit.selling_plan = plan;
        const root = this.closest('.vb-pdp-section');
        const controls = [...root.querySelectorAll('button,input')];
        const states = controls.map(control => control.disabled);
        controls.forEach(control => { control.disabled = true; });
        this.form.setAttribute('aria-busy','true');
        const error = this.querySelector('.vb-gtt-error');
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[kit,{id:this.dataset.variantId,quantity}]})
          });
          if (!response.ok) throw new Error('cart_request_failed');
          window.location.assign(this.dataset.cartUrl);
        } catch (_) {
          error.querySelector('[data-error-text]').textContent = this.dataset.error;
          error.hidden = false;
          this.choice.checked = false;
          controls.forEach((control,index) => { control.disabled = states[index]; });
          this.form.removeAttribute('aria-busy');
          this.busy = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vb-setup-guide-article"] && !Shopify.designMode) return;
  try {
    (() => {
  const setupGuide = (root) => {
    if (root.dataset.guideReady) return;
    root.dataset.guideReady = 'true';
    const body = root.querySelector('[data-guide-body]');
    if (!body) return;
    const cleanText = (element) => element.textContent.replace(/[\s\u00a0\u200b]+/g, ' ').trim();
    body.querySelectorAll('p').forEach((paragraph) => {
      if (!cleanText(paragraph) && !paragraph.id && !paragraph.querySelector('img,picture,video,audio,iframe,svg,canvas,table,input,object,embed,hr,a[id],a[name]')) {
        paragraph.classList.add('vbga-empty');
      }
    });
    const downloads = [...body.querySelectorAll('a[href]')].filter((link) => /\.(pdf|uadmix)(?:[?#]|$)/i.test(link.getAttribute('href')) && cleanText(link));
    downloads.forEach((link) => {
      link.classList.add('vbga-download');
      const paragraph = link.closest('p');
      if (!paragraph || paragraph.parentElement !== body) return;
      let cursor = paragraph.previousElementSibling;
      let steps = 0;
      while (cursor && cursor.tagName === 'P' && steps < 4) {
        cursor = cursor.previousElementSibling;
        steps += 1;
      }
      if (!cursor || !/^H[23]$/.test(cursor.tagName) || !/download/i.test(cleanText(cursor))) return;
      const panel = document.createElement('div');
      panel.className = 'vbga-download-panel';
      body.insertBefore(panel, cursor);
      let node = cursor;
      while (node) {
        const next = node.nextElementSibling;
        panel.append(node);
        if (node === paragraph) break;
        node = next;
      }
      const following = panel.nextElementSibling;
      if (following?.tagName === 'P' && following.style.textAlign === 'center' && cleanText(following) && !following.querySelector('a')) panel.append(following);
    });
    const outline = root.querySelector('[data-guide-outline]');
    const sidebar = root.querySelector('[data-guide-sidebar]');
    const headings = [...body.querySelectorAll('h2,h3')].filter((heading) => !heading.closest('.vbga-download-panel') && cleanText(heading));
    const entries = headings.filter((heading) => heading !== body.firstElementChild);
    if (!outline || !sidebar || entries.length < 3) return;
    const hasSections = entries.some((heading) => heading.tagName === 'H2');
    entries.forEach((heading, index) => {
      if (!heading.id) {
        const base = `${root.id}-section-${index + 1}`;
        let candidate = base;
        let suffix = 1;
        while (document.getElementById(candidate)) candidate = `${base}-${suffix++}`;
        heading.id = candidate;
      }
      const item = document.createElement('li');
      if (hasSections && heading.tagName === 'H3') item.className = 'vbga-outline-sub';
      const link = document.createElement('a');
      link.setAttribute('href', `#${heading.id}`);
      link.textContent = cleanText(heading);
      item.append(link);
      outline.append(item);
    });
    sidebar.hidden = false;
    const outlineDisclosure = sidebar.querySelector('details');
    const wideScreen = window.matchMedia('(min-width: 900px)');
    outlineDisclosure.open = wideScreen.matches;
    wideScreen.addEventListener('change', (event) => { outlineDisclosure.open = event.matches; });
  };
  const initialize = (scope) => scope.querySelectorAll('[data-guide-article]').forEach(setupGuide);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
